import styled from "styled-components";
import type { DividerStyledProps } from "../types";

export const DividerElement = styled.div.attrs<DividerStyledProps>(
  ({ $borderWidth, $borderColor = "var(--theme-color-1)", $round }) => {
    const width = Number($borderWidth) || 1;
    const color = $borderColor ?? "var(--theme-color-1)";
    if ($round === "dashed") {
      const dashPx = width * 3;
      const gapPx = dashPx * 1.5;
      const mask = `repeating-linear-gradient(90deg, #000 0px, #000 ${dashPx}px, transparent ${dashPx}px, transparent ${dashPx + gapPx}px)`;
      return {
        style: {
          height: `${width}px`,
          borderBottom: "none",
          borderRadius: "0",
          background: color,
          maskImage: mask,
          WebkitMaskImage: mask,
        },
      };
    }
    if ($round === "dotted") {
      const dotRadius = width / 2;
      const dotSpacing = width * 3;
      const dotCenter = dotRadius;
      const mask = `radial-gradient(circle at ${dotCenter}px ${width / 2}px, #000 ${dotRadius}px, transparent ${dotRadius}px)`;
      const maskSize = `${dotSpacing}px ${width}px`;
      return {
        style: {
          height: `${width}px`,
          borderBottom: "none",
          borderRadius: "0",
          background: color,
          maskImage: mask,
          WebkitMaskImage: mask,
          maskSize,
          WebkitMaskSize: maskSize,
          maskRepeat: "repeat-x",
          WebkitMaskRepeat: "repeat-x",
        },
      };
    }
    return {
      style: {
        height: `${width}px`,
        borderBottom: "none",
        borderRadius: $round || "0",
        background: color,
      },
    };
  },
)``;
